import createIcon from '../../createIcon';

/**
 * @component @name DashboardCustomize
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAzSDExVjExSDNWM1pNMTMgM0gyMVYxMUgxM1YzWk0zIDEzSDExVjIxSDNWMTNaTTE4IDEzSDE2VjE2SDEzVjE4SDE2VjIxSDE4VjE4SDIxVjE2SDE4VjEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DashboardCustomize = createIcon('DashboardCustomize', [
  [
    'path',
    {
      d: 'M3 3H11V11H3V3ZM13 3H21V11H13V3ZM3 13H11V21H3V13ZM18 13H16V16H13V18H16V21H18V18H21V16H18V13Z',
      key: '1hamno',
    },
  ],
]);

export default DashboardCustomize;
